import { render, staticRenderFns } from "./UploadFile.vue?vue&type=template&id=5daf814c&scoped=true"
import script from "./UploadFile.vue?vue&type=script&lang=js"
export * from "./UploadFile.vue?vue&type=script&lang=js"
import style0 from "./UploadFile.vue?vue&type=style&index=0&id=5daf814c&lang=css"
import style1 from "./UploadFile.vue?vue&type=style&index=1&id=5daf814c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5daf814c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5daf814c')) {
      api.createRecord('5daf814c', component.options)
    } else {
      api.reload('5daf814c', component.options)
    }
    module.hot.accept("./UploadFile.vue?vue&type=template&id=5daf814c&scoped=true", function () {
      api.rerender('5daf814c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/Upload/UploadFile.vue"
export default component.exports